import * as React from 'react';
import { get } from 'lodash';

// components
import BaseScreen from '../../modules/base-screen';
import PlatformSelection from '../../modules/platform-selection';
import { Component as LegalTagline, Utils as LegalTaglineUtils } from '../../../../components/legal-tagline';
import { IAgeRatings } from '@sitegen/common/constants/age-ratings';

export interface IPlatformSelectionScreenProps {
    countryCode: string;
    ratingsConfig: IAgeRatings;
}

interface IPlatformSelectionScreenState {
    legalTaglineEnabled: boolean;
    legalTaglineConfirmed: boolean;
}

class PlatformSelectionScreen extends React.Component<IPlatformSelectionScreenProps, IPlatformSelectionScreenState> {
    constructor(props: IPlatformSelectionScreenProps) {
        super(props);

        const legalTaglineEnabled = LegalTaglineUtils.isLegalTaglineEnabled(get(props, 'ratingsConfig.USK', ''), props.countryCode);

        this.state = {
            legalTaglineEnabled,
            legalTaglineConfirmed: false
        };
    }

    public handleLegalTaglineConfirmationChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const legalTaglineConfirmed = event.target.checked;

        this.setState(prevState => ({
            ...prevState,
            legalTaglineConfirmed
        }));
    };

    public render(): JSX.Element {
        return (
            <BaseScreen>
                <PlatformSelection disabled={this.state.legalTaglineEnabled && !this.state.legalTaglineConfirmed}>
                    {this.state.legalTaglineEnabled && (
                        <LegalTagline value={this.state.legalTaglineConfirmed} onChange={this.handleLegalTaglineConfirmationChange} />
                    )}
                </PlatformSelection>
            </BaseScreen>
        );
    }
}

export default PlatformSelectionScreen;
